
import './App.css';
import logo from './images/image-equilibrium.jpg';
import etherium from './images/icon-ethereum.svg';
import clock from './images/icon-clock.svg';
import avatar from './images/image-avatar.png';
import view from './images/icon-view.svg'

function App() {
  return (
    <div className="App">
      <div className='qr  bg-[#0D1A2D] h-screen flex flex-col justify-center items-center'>
        <div className='w-72 bg-[#142841] rounded-2xl p-3 space-y-3'>
          {/* img */}
          <div className='container-image'>
          <img className='relative rounded-md cursor-pointer' src={logo} alt="" />
          <div>
            <img src={view} alt="" />
          </div>
          </div>
        {/* text */}
        <div className='p-2 flex flex-col  space-y-1 space-x-.5 text-left'>
            <h1 className='font-bold text-white text-[18px] hover:text-[#00FFF8] cursor-pointer'>Equilibrium #3429</h1>
            <p className='text-[#5b779e] text-[15px]'>Our Equilibrium collection promotes balance and calm.</p>
        </div>
        {/* ETH & Days */}
        <div className='icons flex space-x-7  border-solid border-b pb-4 border-[#394350] '>
            <div className='space-x-1'>
            <img src={etherium} align="left" alt="" />
            <span className='text-[#00FFF8]'>0.041 ETH</span>
            </div>
            <div className='space-x-1'>
              <img src={clock} align="left" alt="" />
              <span className='text-[#5b779e]'>3 days left</span>
            </div>
        </div>
        {/* text-creater */}
        <div className='flex items-center justify-center float-left space-x-4 '>
          <img className='space-y-5 border-2 border-solid rounded-full creator border-sky-100 w-9' src={avatar} align="left" alt="" />
          <h2 className='space-y-2 text text-[#5b779e]'>Creation of <span className='text-white hover:text-[#00FFF8] cursor-pointer'>Jules Wyvern</span></h2>
        </div>
      </div>
      </div>
    </div>
  );
}

export default App;
